import Utils from 'components/utils';

const screenBreakpoints = [
    Utils.Breakpoints.XXLARGE,
    Utils.Breakpoints.XLARGE,
    Utils.Breakpoints.LARGE,
    Utils.Breakpoints.MEDIUM,
    Utils.Breakpoints.SMALL
];
const classHidePrefix = "hide-for-";
const classEmptyPrefix = "is-empty-on-";

window.addEventListener('DOMContentLoaded', () => {
    hideEmptyBurgerMenu();
    hideEmptyBurgerMenuOnResize();
});

function hideEmptyBurgerMenu() {
    const burgerMenu = document.querySelector('#page-burger-menu');
    const burgerMenuToggle = document.querySelector('.page-burger-menu-toggle');

    burgerMenuToggle && burgerMenuToggle.classList.remove("hide");

    const responsiveClasses = screenBreakpoints.map(el => classHidePrefix + el);
    const burgerMenus = document.querySelectorAll('#page-burger-menu ul');

    const menuClasses = []
    for (const menuItem of burgerMenus) {
        const cl = responsiveClasses.findLast(el => menuItem.classList.contains(el));
        cl && menuClasses.push(cl);
    }

    if (burgerMenus.length === menuClasses.length) {
        responsiveClasses.every(item => {
            if (menuClasses.indexOf(item) !== -1) {
                burgerMenuToggle && burgerMenuToggle.classList.add(item);
                burgerMenu && burgerMenu.classList.add(item.replace(classHidePrefix, classEmptyPrefix));
                return false;
            }
            return true;
        })
    }
}

function hideEmptyBurgerMenuOnResize() {
    window.addEventListener('resize', () => {
        screenBreakpoints.forEach( cl => {
            if (Utils.breakpoint.match(cl)) {
                const toggle = document.querySelector('#page-burger-menu.' + classEmptyPrefix + cl);
                toggle && toggle.dispatchEvent(new Event('close'));
            }
        })
    })
}